import { removeNamespace } from '@piri/vue-utils';

import RecipeApi from '../RecipeApi';
import moduleName from './moduleName';
import actionTypes from './types/actionTypes';
import mutationTypes from './types/mutationTypes';

const actionTypesInModule = removeNamespace(moduleName, actionTypes);
const mutationTypesInModule = removeNamespace(moduleName, mutationTypes);
const RECIPE_TYPE_NAME = 'recipe';

const retrieveApiDatas = async (context, { options, queryObject }) => {
  const { fetchRecipesApiFromRecipeApi } = RecipeApi();

  return {
    type: RECIPE_TYPE_NAME,
    data: (await fetchRecipesApiFromRecipeApi(options.recipe, queryObject)),
  };
};

const getAuthors = async ({ commit }) => {
  const { fetchAuthorsApi } = RecipeApi();

  commit(mutationTypesInModule.AUTHORS_UPDATED, (await fetchAuthorsApi()));
};

export default {
  [actionTypesInModule.RETRIEVE_API_DATAS]: retrieveApiDatas,
  [actionTypesInModule.GET_AUTHORS]: getAuthors,
};
